import { Message } from "./messages";

const enc = new TextEncoder();
const dec = new TextDecoder();

/** Message -> plaintext bytes (to be encrypted by the secure channel). */
export function encodeMessage(msg: Message): Uint8Array {
  return enc.encode(JSON.stringify(Message.parse(msg)));
}

/** Plaintext bytes -> validated Message. Throws on malformed or unknown input. */
export function decodeMessage(bytes: Uint8Array): Message {
  return Message.parse(JSON.parse(dec.decode(bytes)));
}
